import React, { useState } from 'react';
import { Modal, List, Input, Select, Button, Popconfirm, message, Empty, Tag } from 'antd';
import { EditOutlined, DeleteOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { updateAgendaTag, deleteAgendaTag } from '../../api/agendaTags';
import { NOTE_COLOR_OPTIONS } from '../../constants/agendaNoteColors';

// Tag'lerin sonradan duzenlenip (isim + renk) silinebilmesi icin ayri bir
// yonetim modali - AgendaTagSelect'in dropdown'undan aciliyor. Renk secimi
// notlardaki ile ayni sabit palet (NOTE_COLOR_OPTIONS), serbest renk secici
// degil.
const AgendaTagManageModal = ({ open, onClose, tags, setTags }) => {
  const [editingId, setEditingId] = useState(null);
  const [editLabel, setEditLabel] = useState('');
  const [editColor, setEditColor] = useState('purple');
  const [saving, setSaving] = useState(false);

  const startEdit = (tag) => {
    setEditingId(tag.id);
    setEditLabel(tag.label);
    setEditColor(tag.color || 'purple');
  };

  const handleSave = async (tagId) => {
    if (!editLabel.trim()) {
      message.warning('Tag adı boş olamaz.');
      return;
    }
    setSaving(true);
    try {
      const res = await updateAgendaTag(tagId, { label: editLabel.trim(), color: editColor });
      setTags((prev) => prev.map((t) => (t.id === tagId ? res.data : t)));
      setEditingId(null);
      message.success('Tag güncellendi.');
    } catch (err) {
      message.error(err?.response?.data?.message || 'Tag güncellenemedi.');
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (tagId) => {
    try {
      await deleteAgendaTag(tagId);
      setTags((prev) => prev.filter((t) => t.id !== tagId));
      message.success('Tag silindi.');
    } catch (err) {
      message.error(err?.response?.data?.message || 'Tag silinemedi.');
    }
  };

  return (
    <Modal title="Etiketleri Yönet" open={open} onCancel={onClose} footer={null} width={480}>
      <List
        dataSource={tags}
        locale={{ emptyText: <Empty description="Henüz tag yok." image={Empty.PRESENTED_IMAGE_SIMPLE} /> }}
        renderItem={(tag) => (
          <List.Item>
            {editingId === tag.id ? (
              <div className="flex gap-2 items-center w-full flex-wrap">
                <Input
                  size="small"
                  value={editLabel}
                  onChange={(e) => setEditLabel(e.target.value)}
                  maxLength={100}
                  style={{ width: 140 }}
                />
                <Select value={editColor} onChange={setEditColor} style={{ width: 120 }} size="small">
                  {NOTE_COLOR_OPTIONS.map((c) => (
                    <Select.Option key={c.value} value={c.value}>
                      <span style={{ color: c.hex }}>●</span> {c.label}
                    </Select.Option>
                  ))}
                </Select>
                <Button size="small" type="primary" icon={<CheckOutlined />} loading={saving} onClick={() => handleSave(tag.id)} />
                <Button size="small" icon={<CloseOutlined />} onClick={() => setEditingId(null)} />
              </div>
            ) : (
              <div className="flex justify-between items-center w-full">
                <Tag color={tag.color}>{tag.label}</Tag>
                <div className="flex gap-2">
                  <Button size="small" type="text" icon={<EditOutlined />} onClick={() => startEdit(tag)} />
                  <Popconfirm title="Bu tag'i silmek istediğinize emin misiniz?" onConfirm={() => handleDelete(tag.id)} okText="Evet" cancelText="Hayır">
                    <Button size="small" type="text" danger icon={<DeleteOutlined />} />
                  </Popconfirm>
                </div>
              </div>
            )}
          </List.Item>
        )}
      />
    </Modal>
  );
};

export default AgendaTagManageModal;
